import { Component, OnInit } from "@angular/core";
import { TradeTypeDecisionModalComponent } from "../../modals/trade-type-decision-modal/trade-type-decision-modal.component";
import { ModalService } from "@core-services/modal.service";

@Component({
	selector: "trade-dialog",
	template: "",
	standalone: false
})
export class TradeDialogComponent implements OnInit {
	constructor(private modalService: ModalService) {}

	public ngOnInit(): void {
		this.modalService.create(TradeTypeDecisionModalComponent, {}, { showCloseButton: false }).present();
	}
}
